import { reducer, on } from "ts-action";
import type { ris } from "@progressive-development/politik-model";

import type { DrucksachenListe } from "../service/artefakt-service.js";
import type {
  DrucksacheMitWeg,
  EntscheidungenStammdaten,
} from "../service/entscheidungen-service.js";
import {
  loadDrucksache,
  loadDrucksachenListe,
  loadEntscheidungenStammdaten,
  loadSitzung,
} from "./entscheidungen-actions.js";

/**
 * Reducer von Block 2 — read-only, deshalb kein Merge: Was geladen wurde, gilt.
 *
 * Die Liste hält das GANZE Artefakt; gefiltert wird in der Seite über reine
 * Funktionen. Ein Filterwechsel berührt den Store nicht.
 */
export interface EntscheidungenState {
  /** undefined = noch nie geladen (die Seite bleibt so lange ruhig). */
  liste?: DrucksachenListe;
  /** Das Artefakt war nicht erreichbar — die Seite sagt es, statt leer zu bleiben. */
  listeFehler?: string;
  detail?: DrucksacheMitWeg;
  sitzung?: { sitzung: ris.Meeting; stationen: ris.Beratung[] };
  stammdaten?: EntscheidungenStammdaten;
}

const initialState: EntscheidungenState = {};

export const entscheidungenReducer = reducer<EntscheidungenState>(
  initialState,
  on(loadDrucksachenListe.success, (state, { payload }) => ({
    ...state,
    liste: payload,
    listeFehler: undefined,
  })),
  on(loadDrucksachenListe.fail, (state, { payload }) => ({
    ...state,
    listeFehler: payload instanceof Error ? payload.message : String(payload),
  })),
  on(loadDrucksache.success, (state, { payload }) => ({ ...state, detail: payload })),
  on(loadSitzung.success, (state, { payload }) => ({ ...state, sitzung: payload })),
  on(loadEntscheidungenStammdaten.success, (state, { payload }) => ({
    ...state,
    stammdaten: payload,
  })),
);
